// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PackInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Create or update a credit pack (pack-only fields).
 *
 * Required fields:
 *   name       (string) — display name, non-empty
 *   credits    (int)    — micro-credits to grant; must be > 0
 *   active     (int)    — 0 or 1
 *   sort_order (int)    — display ordering
 *
 * `price_cents` on `ai_credit_packs` is retired (D-l, M6b-1) — real per-market
 * pricing lives in `ai_credit_pack_prices` (see AiCredits_PackMarketInput,
 * the upsert_price() endpoint). It was never read from this contract by
 * create()/update() even before this change; it is now gone from here too.
 */
import { registerContract } from './validate'

export interface AiCredits_PackInput {
name: string
credits: number
active: number
sort_order: number
}

registerContract('AiCredits_PackInput', {
  name:       { type: 'string',  required: true },
  credits:    { type: 'number',  required: true },
  active:     { type: 'number',  required: true },
  sort_order: { type: 'number',  required: true },
})
